var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "px-1 sm:px-12 py-8 font-outfit flex-1" }, [
    _c(
      "div",
      {
        staticClass:
          "flex justify-between items-center mb-4 pb-4 borderMainClientProfile",
      },
      [
        _c("h2", { staticClass: "text-lg font-normal" }, [
          _vm._v("Personal Considerations"),
        ]),
        _c(
          "button",
          {
            staticClass:
              "px-8 py-2 text-16 rounded-full border border-secondary-black hover:bg-gray-50 focus:outline-none",
            on: {
              click: function ($event) {
                return _vm.$emit("edit")
              },
            },
          },
          [_vm._v(" Edit ")]
        ),
      ]
    ),
    _c("div", { staticClass: "flex flex-col gap-5" }, [
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Home Environment"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _c("div", { staticClass: "mb-2" }, [_vm._v("Pets")]),
          _c(
            "ul",
            { staticClass: "list-disc pl-5 space-y-1" },
            _vm._l(_vm.parseObject(_vm.data.pets), function (pet) {
              return _c("li", { key: pet }, [_vm._v(_vm._s(pet))])
            }),
            0
          ),
          _c("div", { staticClass: "mt-4 mb-2" }, [
            _vm._v("Accessibility Issues"),
          ]),
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.data.accessibility_issues
                  ? _vm.data.accessibility_issues
                  : "N/A"
              )
            ),
          ]),
          _c("div", { staticClass: "mt-4 mb-2" }, [_vm._v("Safety Concerns")]),
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.data.safety_concerns ? _vm.data.safety_concerns : "N/A"
              )
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Personal Preferences"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _c("div", { staticClass: "mb-2" }, [_vm._v("Hobbies")]),
          _c(
            "ul",
            { staticClass: "list-disc pl-5 space-y-1" },
            _vm._l(_vm.parseObject(_vm.data.hobbies), function (hobby) {
              return _c("li", { key: hobby }, [_vm._v(_vm._s(hobby))])
            }),
            0
          ),
          _c("div", { staticClass: "mt-4 mb-2" }, [_vm._v("Interests")]),
          _c("div", [
            _vm._v(_vm._s(_vm.data.interests ? _vm.data.interests : "N/A")),
          ]),
          _c("div", { staticClass: "mt-4 mb-2" }, [
            _vm._v("Cultural Considerations"),
          ]),
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.data.cultural_considerations
                  ? _vm.data.cultural_considerations
                  : "N/A"
              )
            ),
          ]),
          _c("div", { staticClass: "mt-4 mb-2" }, [
            _vm._v("Religious Practices"),
          ]),
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.data.religious_practices
                  ? _vm.data.religious_practices
                  : "N/A"
              )
            ),
          ]),
          _c("div", { staticClass: "mt-4 mb-2" }, [
            _vm._v("Dietary Restrictions"),
          ]),
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.data.dietary_restrictions
                  ? _vm.data.dietary_restrictions
                  : "N/A"
              )
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }